import { render } from "./FinancesInfo.vue?vue&type=template&id=50456c02&scoped=true"
import script from "./FinancesInfo.vue?vue&type=script&lang=js"
export * from "./FinancesInfo.vue?vue&type=script&lang=js"

import "./FinancesInfo.vue?vue&type=style&index=0&id=50456c02&scoped=true&lang=scss"

import exportComponent from "/Users/alex/lab_dev_test/info-global/info_front_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50456c02"]])

export default __exports__